import React,{useState} from 'react';
import CreateWorflowTransaction from "./Workflow Transaction Contents/Workflow Transaction Creation";
import WorkflowTransactionList from "./Workflow Transaction Contents/Worflow Transaction List";


const WorkflowTransaction = ({isSubflow,handleSubflowCanvasClick,isTransaction, workflow }) => {
  const [createTransaction, setCreateTransaction] = useState(false);
  console.log('in transaction page',workflow);
const workflowJson = {
  "nodes": [
    {
      "id": "0",
      "type": "subflowNode",
      "position": {
        "x": 48.234375,
        "y": 65.875
      },
      "data": {
        "label": "L1",
        "level": "L1",
        "icon": null,
        "color": "#fff",
        "fontColor": "#000",
        "fontSize": "12px",
        "fontStyle": "normal",
        "recData": {
          "color": "#02acf6",
          "fontColor": "#121b45"
        },
        "permissionData": {
          " hrRecruiter": {
            " read": true,
            " write": false,
            "hide": false
          }
        },
        "nodeData":{
            "nodes": [
              {
                "id": "0",
                "type": "rectangle",
                "position": {
                  "x": -92.265625,
                  "y": -29.125
                },
                "data": {
                  "label": "View Candidate Info",
                  "icon": null,
                  "color": "#d0021b",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              },
              {
                "id": "1",
                "type": "rectangle",
                "position": {
                  "x": -123.3984375,
                  "y": 32.0625
                },
                "data": {
                  "label": "HR override",
                  "icon": null,
                  "color": "#f5a623",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              },
              {
                "id": "2",
                "type": "rectangle",
                "position": {
                  "x": 178.1015625,
                  "y": 90.5625
                },
                "data": {
                  "label": "Next button = enable",
                  "icon": null,
                  "color": "#8b572a",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              },
              {
                "id": "3",
                "type": "diamond",
                "position": {
                  "x": 14.1015625,
                  "y": 37.5625
                },
                "data": {
                  "label": "Status=Approved",
                  "icon": null,
                  "color": "#f8e71c",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "diamond"
                }
              },
              {
                "id": "5",
                "type": "diamond",
                "position": {
                  "x": -54.8984375,
                  "y": 109.5625
                },
                "data": {
                  "label": "Status=Rejected",
                  "icon": null,
                  "color": "#7ed321",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "diamond"
                }
              },
              {
                "id": "6",
                "type": "rectangle",
                "position": {
                  "x": 70.50535739603026,
                  "y": 203.55870510396977
                },
                "data": {
                  "label": " Rejected Email",
                  "icon": null,
                  "color": "#bd10e0",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              },
              {
                "id": "7",
                "type": "rectangle",
                "position": {
                  "x": 337.6015625,
                  "y": -23.037499999999966
                },
                "data": {
                  "label": "Add Candidate Info",
                  "icon": null,
                  "color": "#4a90e2",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45",
           
                    "fieldsAndConditions": [{
          "FieldName": "CurrentCTC",
          "SelectedTasks" : [{
                          "Name" : "Tsk_ColorChange",
                            "Rules" : [{
                              "Name": "ChangeBGColor()",
                              "Properties" : [{
                                "Condition" : "Value > 2000000",
                                "Value" : "#FF0000"
                              },
                              {
                                "Condition" : "Value < 2000000",
                                "Value" : "#008000"
                              }]
                            },
                            {
                              "Name": "ChangeTextColor()",
                              "Properties" : [{
                                "Condition" : "Value > 1000000",
                                "Value" : "#FFFFFF"
                              },
                              {
                                "Condition" : "Value <= 1000000",
                                "Value" : "#F0F0F0"
                              }]
                            }]
                        }]
                    },
                    {
          "FieldName": "PhoneNumber",
          "SelectedTasks" : [{
                          "Name" : "Tsk_PhoneNumber",
                            "Rules" : [{
                              "Name": "RemoveLeadingZeros()",
                              "Properties" : []
                            },
                            {
                              "Name": "MaxLength()",
                              "Properties" : [{
                                "Condition" : "",
                                "Value" : "15"
                              }]
                            }]
                        },
          {
                          "Name" : "Tsk_TrimBothSides",
                            "Rules" : [{
                              "Name": "Trim()",
                              "Properties" : []
                            }]
                        }]
                    }          
                    ]
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              },
              {
                "id": "9",
                "type": "rectangle",
                "position": {
                  "x": 400.6015625,
                  "y": 148.5106025519849
                },
                "data": {
                  "label": "SendMail_To_Candidate",
                  "icon": null,
                  "color": "#b8e986",
                  "fontColor": "#000",
                  "fontSize": "12px",
                  "fontStyle": "normal",
                  "recData": {
                    "color": "#02acf6",
                    "fontColor": "#121b45"
                  },
                  "permissionData": {
                    " hrRecruiter": {
                      " read": true,
                      " write": false,
                      "hide": false
                    }
                  },
                  "showIcons": false,
                  "type": "rectangle"
                }
              }
            ],
            "edges": [
              {
                "id": "edge-3-right-source-2-top-target",
                "source": "3",
                "target": "2",
                "sourceHandle": "3-right-source",
                "targetHandle": "2-top-target",
                "type": "edges",
                "label": "yes",
                "markerEnd": {
                  "type": "arrowclosed",
                  "width": 10,
                  "height": 10,
                  "color": "#121b45"
                },
                "style": {},
                "animated": false
              },
              {
                "id": "edge-3-bottom-source-5-top-target",
                "source": "3",
                "target": "5",
                "sourceHandle": "3-bottom-source",
                "targetHandle": "5-top-target",
                "type": "edges",
                "label": "No",
                "markerEnd": {
                  "type": "arrowclosed",
                  "width": 10,
                  "height": 10,
                  "color": "#121b45"
                },
                "style": {},
                "animated": false
              },
              {
                "id": "edge-7-bottom-source-9-top-target",
                "source": "7",
                "target": "9",
                "sourceHandle": "7-bottom-source",
                "targetHandle": "9-top-target",
                "type": "edges",
                "label": "",
                "markerEnd": {
                  "type": "arrowclosed",
                  "width": 10,
                  "height": 10,
                  "color": "#121b45"
                },
                "style": {},
                "animated": false
              },
              {
                "id": "edge-5-right-source-6-top-target",
                "source": "5",
                "target": "6",
                "sourceHandle": "5-right-source",
                "targetHandle": "6-top-target",
                "type": "edges",
                "label": "yes",
                "markerEnd": {
                  "type": "arrowclosed",
                  "width": 10,
                  "height": 10,
                  "color": "#121b45"
                },
                "style": {
                  "position": "relative",
                  "strokeDasharray": "0,0"
                },
                "animated": false
              }
            ],
            "dropdownData": {
    "client": "--select--",
    "department": "--select--",
    "workflowName": "WF-TMP-CUDI-DEV-0215",
    "level": "L1"
  }
          },
        "showIcons": false
      }
    },
    {
      "id": "1",
      "type": "subflowNode",
      "position": {
        "x": 185.1015625,
        "y": 124.5625
      },
      "data": {
        "label": "L2",
        "level": "L2",
        "icon": null,
        "color": "#fff",
        "fontColor": "#000",
        "fontSize": "12px",
        "fontStyle": "normal",
        "recData": {
          "color": "#02acf6",
          "fontColor": "#121b45"
        },
        "permissionData": {
          " hrRecruiter": {
            " read": true,
            " write": false,
            "hide": false
          }
        },
        "nodeData":{
"nodes":[

  {
                  "id": "0",
                  "type": "rectangle",
                  "position": {
                    "x": -92.265625,
                    "y": -29.125
                  },
                  "data": {
                    "label": "Add Candidate Info",
                    "icon": null,
                    "color": "#d0021b",
                    "fontColor": "#000",
                    "fontSize": "12px",
                    "fontStyle": "normal",
                    "recData": {
                      "color": "#02acf6",
                      "fontColor": "#121b45"
                    },
                    "permissionData": {
                      " hrRecruiter": {
                        " read": true,
                        " write": false,
                        "hide": false
                      }
                    },
                    "showIcons": false,
                    "type": "rectangle"
                  }
                },

                {
                  "id": "1",
                  "type": "rectangle",
                  "position": {
                    "x": -123.3984375,
                    "y": 32.0625
                  },
                  "data": {
                    "label": "Cdte_Added",
                    "icon": null,
                    "color": "#f5a623",
                    "fontColor": "#000",
                    "fontSize": "12px",
                    "fontStyle": "normal",
                    "recData": {
                      "color": "#02acf6",
                      "fontColor": "#121b45"
                    },
                    "permissionData": {
                      " hrRecruiter": {
                        " read": true,
                        " write": false,
                        "hide": false
                      }
                    }
                }
            }
],
"edges":[
    {
        "id": "edge-0-bottom-source-1-top-target",
        "source": "0",
        "target": "1",
        "sourceHandle": "0-bottom-source",
        "targetHandle": "1-top-target",
        "type": "edges",
        "label": "",
        "markerEnd": {
          "type": "arrowclosed",
          "width": 10,
          "height": 10,
          "color": "#121b45"
        },
        "style": {},
        "animated": false
      },
],
"dropdownData": {
    "client": "--select--",
    "department": "--select--",
    "workflowName": "WF-TMP-CUDI-DEV-0215",
    "level": "L2"
  }
},
        "showIcons": false
      }
    }
 
  ],
  "edges": [
    {
      "id": "edge-0-bottom-source-1-top-target",
      "source": "0",
      "target": "1",
      "sourceHandle": "0-bottom-source",
      "targetHandle": "1-top-target",
      "type": "edges",
      "label": "",
      "markerEnd": {
        "type": "arrowclosed",
        "width": 10,
        "height": 10,
        "color": "#121b45"
      },
      "animated": false
    }
 
  ],
  "dropdownData": {
    "client": "CU-Direct",
    "department": "QA Automation",
    "workflowName": "--select--",
    "level": "--select--"
  }
}

const subflowJson = 
  {
    "nodes": [
      {
        "id": "0",
        "type": "rectangle",
        "position": {
          "x": 163.5,
          "y": 49.875
        },
        "data": {
          "label": "Add-Candidate",
          "icon": "/static/media/add_candidate_info.38e5dff17eaee976f059418389f40dd5.svg",
          "color": "#fff",
          "fontColor": "#000",
          "fontSize": "12px",
          "fontStyle": "normal",
          "recData": {
            "color": "#02acf6",
            "fontColor": "#121b45"
          },
          "permissionData": {
            " hrRecruiter": {
              " read": true,
              " write": false,
              "hide": false
            }
          }
        }
      },
      {
        "id": "1",
        "type": "oval",
        "position": {
          "x": 30.5,
          "y": -22.4375
        },
        "data": {
          "label": "type",
          "icon": null,
          "color": "#fff",
          "fontColor": "#000",
          "fontSize": "12px",
          "fontStyle": "normal",
          "recData": {
            "color": "#02acf6",
            "fontColor": "#121b45"
          },
          "permissionData": {
            " hrRecruiter": {
              " read": true,
              " write": false,
              "hide": false
            }
          }
        }
      },
      {
        "id": "2",
        "type": "diamond",
        "position": {
          "x": 27.5,
          "y": 111.5625
        },
        "data": {
          "label": "HR_Override",
          "icon": "/static/media/HR Override (Reject).aada51db5afbd2181dd28787a71f6bfe.svg",
          "color": "#fff",
          "fontColor": "#000",
          "fontSize": "12px",
          "fontStyle": "normal",
          "recData": {
            "color": "#02acf6",
            "fontColor": "#121b45"
          },
          "permissionData": {
            " hrRecruiter": {
              " read": true,
              " write": false,
              "hide": false
            }
          }
        }
      },
      {
        "id": "3",
        "type": "rectangle",
        "position": {
          "x": 204.5,
          "y": 169.0625
        },
        "data": {
          "label": "type",
          "icon": null,
          "color": "#fff",
          "fontColor": "#000",
          "fontSize": "12px",
          "fontStyle": "normal",
          "recData": {
            "color": "#02acf6",
            "fontColor": "#121b45"
          },
          "permissionData": {
            " hrRecruiter": {
              " read": true,
              " write": false,
              "hide": false
            }
          }
        }
      }
    ],
    "edges": [
      {
        "id": "edge-1-bottom-source-0-top-target",
        "source": "1",
        "target": "0",
        "sourceHandle": "1-bottom-source",
        "targetHandle": "0-top-target",
        "type": "edges",
        "label": "",
        "markerEnd": {
          "type": "arrowclosed",
          "width": 10,
          "height": 10,
          "color": "#121b45"
        },
        "animated": false
      },
      {
        "id": "edge-0-bottom-source-2-top-target",
        "source": "0",
        "target": "2",
        "sourceHandle": "0-bottom-source",
        "targetHandle": "2-top-target",
        "type": "edges",
        "label": "",
        "markerEnd": {
          "type": "arrowclosed",
          "width": 10,
          "height": 10,
          "color": "#121b45"
        },
        "animated": false
      },
      {
        "id": "edge-2-dB-3-top-target",
        "source": "2",
        "target": "3",
        "sourceHandle": "2-dB",
        "targetHandle": "3-top-target",
        "type": "edges",
        "label": "",
        "markerEnd": {
          "type": "arrowclosed",
          "width": 10,
          "height": 10,
          "color": "#121b45"
        },
        "animated": false
      }
    ]
  };

  const handleClick = () => {
    setCreateTransaction(true);
  };
  const handleBackClick = () => {
    setCreateTransaction(false);
  };

  return !createTransaction ? (
    <>
      <WorkflowTransactionList onHandleClick={handleClick} /> 
    </>
  ) : (
    <>
      <CreateWorflowTransaction onBackClick={handleBackClick} json={workflowJson} isSubflow = {isSubflow} handleSubflowCanvasClick= {handleSubflowCanvasClick} isTransaction ={isTransaction} workflow ={workflow}
     Client={workflowJson.dropdownData.client} department={workflowJson.dropdownData.department}/>
    </>
  );
};
export default WorkflowTransaction;